import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import DeleteModal from "../../components/modals/deleteModal";
import {
  fieldForceDelete,
  fieldForceDetail,
  reportingFFList,
} from "../../redux/actions/fieldForceAction";
import link from "../../assets/icons/link.svg";
import edit from "../../assets/icons/edit.svg";
import delet from "../../assets/icons/delete-bin.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import inactive from "../../assets/inactive.svg";
import back from "../../assets/back.svg";
import "./fieldForce.css";
import LinkEmpModal from "../../components/modals/LinkEmpModal";
import DeletedPopUp from "../../components/popups/DeletedPopUp";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import styled from "@emotion/styled";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorMsg from "../../components/form/errorMsg";
import Select from "react-select";
import { Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import SubordinatesTaleModal from "../../components/modals/Customer/subordinatesTbaleModal";
import TeamMatesTableModal from "../../components/modals/Customer/teammatesTableModal";
import CustomersTableModal from "../../components/modals/Customer/customerTableModal";

const FieldForceView = ({ maxWidth = "85rem" }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );
  const renderLinkTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      LINK TO OTHER EMPLOYEE ID
    </Tooltip>
  );

  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [fieldForceData, setFieldForceData] = useState(null);
  const [reportingManager, setReportingManager] = useState([]);
  const [delShow, setDelShow] = useState(false);
  const [linkShow, setLinkShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loding, setLoding] = useState(false);
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState("");
  const [subordinateModalOpen, setSubordinateModalOpen] = useState(false);
  const [teammatesModalOpen, setTeammatesModalOpen] = useState(false);
  const [customeersModalOpen, setCustomeersModalOpenn] = useState(false);

  const initialValues = {
    employee_id: "",
    employee_name: "",
    employees: [{ designation_id: "" }],
  };

  const validationSchema = Yup.object().shape({
    employee_id: Yup.string().required("Required"),
    employee_name: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    console.log(values);
  };

  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  useEffect(() => {
    fetchFFdetail();
    dispatch(
      reportingFFList({ user_id: params.id }, onFFListSuccess, onFFListError)
    );
  }, []);

  const onFFListSuccess = (data) => {
    setReportingManager(data);
  };
  const onFFListError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const fetchFFdetail = () => {
    setLoding(true);
    dispatch(fieldForceDetail(params.id, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoding(false);
    setFieldForceData(data.data.data);
  };

  const onError = (err) => {
    setLoding(false);
    console.log(err);
  };

  const delFunc = () => {
    dispatch(fieldForceDelete(fieldForceData?.id, onDelSuccess, onDelError));
  };

  const onDelSuccess = (data) => {
    console.log(data);
    setDelShow(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/field-force/user");
    };

    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDelError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/field-force/user", breadcrumb: " / field force / users" },
    {
      path: "/field-force/user/view/:id",
      breadcrumb: fieldForceData?.user_id
        ? ` / ${fieldForceData?.user_id} - view`
        : " / view",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const filteredData = fieldForceData?.usersOfHeadQuarters?.filter((item) =>
    status == null ? item : item?.status === status && item
  );

  const ffusers = [
    {
      label: "User 1",
      value: "user 1",
    },
    {
      label: "User 2",
      value: "user 2",
    },
    {
      label: "User 3",
      value: "user 3",
    },
    {
      label: "User 4",
      value: "user 4",
    },
  ];

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2 d-none d-xl-block">
                <VersionHistoryBtn
                  link={`/field-force/user/version-history-detail/${fieldForceData?.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    {fieldForceData?.status && (
                      <AdminButton
                        background="#2AD3E7"
                        color="white"
                        width="300px"
                        onClick={() => setLinkShow(true)}
                      >
                        <img src={link} alt="link" />
                        <span className="m-2">LINK TO OTHER EMPLOYEE ID</span>
                      </AdminButton>
                    )}
                    <AdminButton
                      background="#7065E4"
                      color="white"
                      width="100px"
                      onClick={() =>
                        navigate(`/field-force/user/edit/${fieldForceData?.id}`)
                      }
                    >
                      <span className="m-2">EDIT</span>
                    </AdminButton>
                    <AdminButton
                      background="#FF6F5B"
                      color="white"
                      width="100px"
                      onClick={() => setDelShow(true)}
                    >
                      <span className="m-2">DELETE</span>
                    </AdminButton>
                  </>
                ) : (
                  " "
                )}
              </div>
              <div className="d-xl-none">
                <VersionHistoryBtn
                  link={`/field-force/version-history-detail/${fieldForceData?.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    {fieldForceData?.status && (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderLinkTooltip}
                      >
                        <button className="link-small-btn py-2 px-3 m-2">
                          <img src={link} alt="link" />
                        </button>
                      </OverlayTrigger>
                    )}

                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <button
                        className="edit-small-btn py-2 px-3 m-2"
                        onClick={() =>
                          navigate(`/field-force/edit/${fieldForceData?.id}`)
                        }
                      >
                        <img src={edit} alt="edit" />
                      </button>
                    </OverlayTrigger>
                    <button
                      className="delete-small-btn py-2 px-3 m-2"
                      onClick={() => setDelShow(true)}
                    >
                      <img src={delet} alt="delete" />
                    </button>
                  </>
                ) : (
                  " "
                )}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loding == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  <div className="ps-4 ps-lg-4 ms-3 mt-4 col-lg-10 col-md-6 col-10 ">
                    <div className="my-4 d-flex">
                      <div>
                        <label className="color_747f9e fs_14">User ID</label>
                        <p className="fs_14">
                          {fieldForceData?.user_id
                            ? fieldForceData?.user_id
                            : "--"}
                        </p>
                      </div>
                      <div className="my-3 mx-3">
                        <>
                          {fieldForceData?.status ? (
                            <div className="active-container px-2">
                              <img src={active} className="mx-1" />
                              <span className="active-text fs_14">Active</span>
                            </div>
                          ) : (
                            <div className="inactive-container px-2">
                              <img src={inactive} className="mx-1" />
                              <span className="text-danger fs_14">
                                Inactive
                              </span>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">
                        Field Force Code
                      </label>
                      <p className="fs_14">
                        {fieldForceData?.code ? fieldForceData?.code : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">
                        Company Employee ID
                      </label>
                      <p className="fs_14">
                        {" "}
                        {fieldForceData?.employee_id
                          ? fieldForceData?.employee_id
                          : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">
                        Employee Name
                      </label>
                      <p className="fs_14">
                        {fieldForceData?.name ? fieldForceData?.name : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">Phone Number</label>
                      <p className="fs_14">
                        +91{" "}
                        {fieldForceData?.mobile ? fieldForceData?.mobile : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">
                        Email Address
                      </label>
                      <p className="fs_14">
                        {fieldForceData?.email ? fieldForceData?.email : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">Designation</label>
                      <p className="fs_14 text-capitalize">
                        {fieldForceData?.fieldForceDesignation?.name
                          ? fieldForceData?.fieldForceDesignation?.name
                          : "--"}
                      </p>
                    </div>
                    <div className="my-4">
                      <label className="color_747f9e fs_14">
                        Designation Approval level
                      </label>
                      <p className="fs_14 text-capitalize">
                        {fieldForceData?.fieldForceDesignation?.approval_level
                          ? fieldForceData?.fieldForceDesignation
                              ?.approval_level
                          : "--"}
                      </p>
                    </div>
                    {fieldForceData?.fieldForceDesignation?.approval_level !=
                      "admin" && (
                      <>
                        <div className="my-4">
                          <label className="color_747f9e fs_14">
                            Division Name
                          </label>
                          <p className="fs_14">
                            {/* {fieldForceData?.vendorDivision?.name} */}
                            {fieldForceData?.fieldForceDivisions?.length > 0 &&
                              fieldForceData?.fieldForceDivisions?.map(
                                (ele, index) => {
                                  return (
                                    <span key={index}>
                                      {index ? (
                                        <span className="mx-1 color_b0b3c7">
                                          |
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      {ele?.vendorDivision?.name}
                                    </span>
                                  );
                                }
                              )}
                          </p>
                        </div>
                        <div className="my-4">
                          <label className="color_747f9e fs_14">
                            Head Quaters
                          </label>
                          <p className="fs_14">
                            {fieldForceData?.fieldForceUserHeadQuaters?.length >
                              0 &&
                              fieldForceData?.fieldForceUserHeadQuaters?.map(
                                (ele, index) => {
                                  return (
                                    <span key={index}>
                                      {index ? (
                                        <span className="mx-1 color_b0b3c7">
                                          |
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      {ele?.headQuater?.name}
                                    </span>
                                  );
                                }
                              )}
                          </p>
                        </div>
                        <div className="my-4">
                          <label className="color_747f9e fs_14">
                            Reporting Manager
                          </label>
                          <p className="fs_14 text-capitalize">
                            {fieldForceData?.reportingManager?.name
                              ? fieldForceData?.reportingManager?.name
                              : "--"}
                          </p>
                        </div>
                        {fieldForceData?.fieldForceUserLinkedEmployees?.length >
                          0 && (
                          <div className="my-4">
                            <label className="color_747f9e fs_14">
                              Linked With
                            </label>
                            <p className="fs_14 color_2ad3e7 ">
                              {fieldForceData?.fieldForceUserLinkedEmployees
                                ?.length > 0 &&
                                fieldForceData?.fieldForceUserLinkedEmployees?.map(
                                  (ele, index) => {
                                    return (
                                      <span key={index}>
                                        {index ? (
                                          <span className="mx-1 color_b0b3c7">
                                            |
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                        {ele?.fieldForceUser?.employee_id}
                                      </span>
                                    );
                                  }
                                )}
                            </p>
                          </div>
                        )}
                      </>
                    )}
                    <div className="my-4 mt-5 row gap-4">
                      <AdminButton
                        background="#7065E4"
                        color="white"
                        width="160px"
                        onClick={() => setSubordinateModalOpen(true)}
                      >
                        <span className="m-2 fw_700 text-uppercase">
                          Suboridinates
                        </span>
                      </AdminButton>

                      <AdminButton
                        background="#24D626"
                        color="white"
                        width="160px"
                        onClick={() => setCustomeersModalOpenn(true)}
                      >
                        <span className="m-2 fw_700 text-uppercase">
                          Customers
                        </span>
                      </AdminButton>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* <>
            <div className="my-2 mt-5">
              <p className="header-route-page fw_400 cursor_pointer mx-3">
                USER APPROVAL
              </p>
            </div>
            <div
              style={{ minHeight: "18rem" }}
              className="products-main-list my-2 d-flex justify-content-between flex-column p-4"
            >
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ setFieldValue, values }) => (
                  <Form className="">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <p className="header-route-page fw_400 cursor_pointer fs_14">
                          Select Allocation Type
                        </p>
                        <AdminButton
                          background="##FFFFFF"
                          width="140px"
                          border={"1px solid #E7E5FF"}
                          // onClick={() => clearFunc(setFieldValue)}
                        >
                          CUSTOM
                        </AdminButton>
                        <AdminButton
                          background="#7065e4"
                          color="white"
                          width="140px"
                        >
                          <span className="m-2">Auto</span>
                        </AdminButton>
                      </div>
                      <div>
                        <AdminButton
                          background="#7065e4"
                          color="white"
                          width="280px"
                          type="submit"
                          borderRadius="7px"
                        >
                          <span className="m-2">SAVE</span>
                        </AdminButton>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-5 my-4">
                      <div className="my-2 col-xxl-3 col-4">
                        <InputCapitalField
                          setFieldValue={setFieldValue}
                          id={"employee_id"}
                          label={"Field Force Name"}
                          labelColor={"color_262c3d"}
                          type={"text"}
                          placeholder={"Enter field force Name"}
                          name={"employee_id"}
                          value={values?.employee_id}
                        />
                      </div>
                      <div>
                        <img
                          src={UpArrow}
                          alt="z"
                          style={{ rotate: "90deg" }}
                        />
                      </div>
                      <div className="my-2 col-xxl-3 col-4">
                        <label className="color_262c3d fw_400 fs_14 my-1">
                          Field Force Employee
                        </label>
                        <Field>
                          {({ form, Field }) => (
                            <Select
                              options={ffusers}
                              styles={customStyles}
                              {...Field}
                              placeholder={"Select the option"}
                              id="designation_id"
                              value={""}
                              onChange={(selectedOption) => {
                                // form.setFieldValue(
                                //   "designation_id",
                                //   selectedOption.value
                                // );
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="designation_id" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </>
          <>
            <div className="my-2 mt-5">
              <p className="header-route-page fw_400 cursor_pointer mx-3">
                ORDER APPROVAL
              </p>
            </div>
            <div
              style={{ minHeight: "18rem" }}
              className="products-main-list my-2 d-flex justify-content-between flex-column p-4"
            >
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <p className="header-route-page fw_400 cursor_pointer fs_14">
                          Select Allocation Type
                        </p>
                        <AdminButton
                          background="##FFFFFF"
                          width="140px"
                          border={"1px solid #E7E5FF"}
                          // onClick={() => clearFunc(setFieldValue)}
                        >
                          CUSTOM
                        </AdminButton>
                        <AdminButton
                          background="#7065e4"
                          color="white"
                          width="140px"
                        >
                          <span className="m-2">Auto</span>
                        </AdminButton>
                      </div>
                      <div>
                        <AdminButton
                          background="#7065e4"
                          color="white"
                          width="280px"
                          type="submit"
                          borderRadius="7px"
                        >
                          <span className="m-2">SAVE</span>
                        </AdminButton>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center gap-4 my-4">
                      <div className="my-2 col-xxl-2 col-4">
                        <InputCapitalField
                          setFieldValue={setFieldValue}
                          id={"employee_id"}
                          label={"Field Force Name"}
                          labelColor={"color_262c3d"}
                          type={"text"}
                          placeholder={"Enter field force Name"}
                          name={"employee_id"}
                          value={values?.employee_id}
                        />
                      </div>
                      {values.employees.map((employee, index) => (
                        <>
                          <div>
                            <img
                              src={UpArrow}
                              alt="z"
                              style={{ rotate: "90deg" }}
                            />
                          </div>
                          <div
                            key={index}
                            className="my-2 col-xxl-2 col-4 mb-3 pb-3"
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <label className="color_262c3d fw_400 fs_14 my-1">
                                Field Force Employee
                              </label>
                              {index > 0 && (
                                <label
                                  type="button"
                                  onClick={() => {
                                    const updatedEmployees =
                                      values.employees.filter(
                                        (_, i) => i !== index
                                      );
                                    setFieldValue(
                                      "employees",
                                      updatedEmployees
                                    );
                                  }}
                                  className="fs_12 color-danger cursor_pointer fw_700"
                                >
                                  Remove
                                </label>
                              )}
                            </div>
                            <Select
                              options={ffusers}
                              styles={customStyles}
                              placeholder="Select the option"
                              value={ffusers.find(
                                (option) =>
                                  option.value === employee.designation_id
                              )}
                              onChange={(selectedOption) => {
                                const updatedEmployees = [...values.employees];
                                updatedEmployees[index].designation_id =
                                  selectedOption.value;
                                setFieldValue("employees", updatedEmployees);
                              }}
                            />
                          </div>
                        </>
                      ))}

                      <AdminButton
                        background="#7065e4"
                        color="white"
                        width="140px"
                        onClick={() => {
                          const lastEmployee =
                            values.employees[values.employees.length - 1];
                          if (lastEmployee.designation_id) {
                            setFieldValue("employees", [
                              ...values.employees,
                              { designation_id: "" },
                            ]);
                          } else {
                            alert(
                              "Please select a value before adding another."
                            );
                          }
                        }}
                        disabled={
                          !values.employees[values.employees.length - 1]
                            .designation_id
                        }
                      >
                        <span className="m-2">ADD</span>
                      </AdminButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </> */}
        </div>
        <DeleteModal
          title={`this employee - ${fieldForceData?.user_id}`}
          show={delShow}
          handleClose={() => setDelShow(false)}
          delFunc={delFunc}
        />
        <DeletedPopUp
          title={`Field Force User - ${fieldForceData?.user_id}`}
          show={deletedPop}
        />
        <LinkEmpModal
          show={linkShow}
          handleClose={() => setLinkShow(false)}
          user_id={fieldForceData?.user_id}
          employee_id={fieldForceData?.employee_id}
          field_force_id={params.id}
          fetchFFdetail={fetchFFdetail}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
        <SubordinatesTaleModal
          reportingManager={reportingManager}
          show={subordinateModalOpen}
          ShowClose={() => setSubordinateModalOpen(false)}
        />
        <CustomersTableModal
          reportingManager={reportingManager}
          show={customeersModalOpen}
          ShowClose={() => setCustomeersModalOpenn(false)}
        />
      </div>
    </>
  );
};

export default FieldForceView;

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderRadius: "15px",

    maxWidth: "50rem",
    height: "25rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
